var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm-8.368 3.971l5.565-5.564a.484.484 0 000-.685l-.684-.684a.484.484 0 00-.685 0L6.29 9.076 4.172 6.957a.484.484 0 00-.685 0l-.684.685a.484.484 0 000 .684l3.145 3.145a.484.484 0 00.684 0z",
    fill: "#A4CE4E"
  })));
};

export default SvgCheckMark;